// extracted by mini-css-extract-plugin
export var breakFlex = "Header-module--break-flex--d11e8";
export var nav = "Header-module--nav--5b639";
export var slash = "Header-module--slash--337b3";